import React from "react";
import BatchQuickTaleDetailsContainer from "../../modules/OrganizationBatches/containers/BatchQuickTaleDetailsContainer/BatchQuickTaleDetailsContainer";

const BatchQuickTaleDetails = () => {
  return <BatchQuickTaleDetailsContainer />;
};

export default BatchQuickTaleDetails;
